import { render, staticRenderFns } from "./VisualAssetCard.vue?vue&type=template&id=52c87dda&scoped=true&"
import script from "./VisualAssetCard.vue?vue&type=script&lang=js&"
export * from "./VisualAssetCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c87dda",
  null
  
)

export default component.exports